import { useEffect, useMemo } from "react";

interface PageSizeSelectorProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  options?: number[];
}

const DEFAULT_OPTIONS = [25, 50, 100];

export function PageSizeSelector({
  value,
  onChange,
  disabled = false,
  options = DEFAULT_OPTIONS,
}: PageSizeSelectorProps) {
  useEffect(() => {
    if (value < 25) {
      onChange(25);
    }
  }, [value, onChange]);
  const availableOptions = useMemo(() => {
    // If the current value is not in the predefined options, add it
    if (!options.includes(value)) {
      return [...options, value].sort((a, b) => a - b);
    }
    return options;
  }, [options, value]);

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="pageSize" className="text-sm text-[--ink-muted]">
        Show:
      </label>
      <select
        id="pageSize"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        className="text-sm px-2 py-1 rounded border border-[--line] bg-[--bg] text-[--ink]"
      >
        {availableOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
}
